import React from 'react';
import PropTypes from 'prop-types';
import * as CustomPropTypes from 'semantic-ui-react/dist/commonjs/lib/customPropTypes';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import DropdownText from 'semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownText';
import '@purple/semantic-ui-purple-theme/components/dropdown.css';

import './styles.css';

export default class AccessibleDropdown extends Dropdown {
  static propTypes = {
    ...Dropdown.propTypes,
    // SUI Dropdown disallows using trigger in combination with selection, however, we found this to work (see CollegeEventsEditEvent);
    // overriding this here avoids PropTypes errors polluting the console during tests
    trigger: CustomPropTypes.every([CustomPropTypes.disallow([/* 'selection', */'text']), PropTypes.node]),
  }

  constructor(...args) {
    super(...args);
    this._extend('renderMenu', 'wrapMenu');
  }

  _extend(fnName, overrideFn) {
    const original = this[fnName];
    this[fnName] = (...args) => {
      const results = original(...args);
      return this[overrideFn](results, ...args);
    };
  }

  renderHiddenText() {
    const { multiple, text } = this.props;
    const { selectedIndex, open } = this.state;

    let selectedItem;
    let _text;

    if (text) {
      _text = text;
    } else if (open && !multiple) {
      selectedItem = this.getSelectedItem(selectedIndex);
    }
    if (selectedItem) {
      _text = selectedItem.accessibility || selectedItem.text || _text || '';
    }

    return (
      <DropdownText styleName="hidden">
        { _text }
      </DropdownText>
    );
  }

  wrapMenu(menu) {
    return (
      <React.Fragment>
        {!!this.props.trigger && this.renderHiddenText()}
        {menu}
      </React.Fragment>
    );
  }
}
